import { useEffect, useState } from 'react'

import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'
import { CustomEvents } from 'shared/constants/customEvents'

export const TicketModal = () => {
  const [selectedTicketId, setSelectedTicketId] = useState<string | null>(null)

  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_TASKMANAGEMENT_APP_V2_DEV_PATH,
    'task_management',
    './TaskManagementAppComponents',
    'taskManagementAppV2'
  )

  // @ts-expect-error: dynamic import
  const { TicketModalForm } =
    isLoaded && !isError && !missingRemoteUrl && module
      ? module
      : { TicketModalForm: () => <></> }

  const openTaskManagementTicketModal = (ticketId: string) => {
    setSelectedTicketId(ticketId)
  }

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return

      if (event.data?.type === CustomEvents.OPEN_TICKET_MODAL) {
        const { ticketId } = event.data.payload || {}
        if (ticketId) {
          openTaskManagementTicketModal(ticketId)
        }
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  if (!selectedTicketId) return null

  return (
    <TicketModalForm
      ticketId={selectedTicketId}
      onCloseExternalCallback={() => {
        setSelectedTicketId(null)
        window.postMessage(
          { type: CustomEvents.TICKET_MODAL_CLOSED },
          window.location.origin
        )
      }}
    />
  )
}
